const MuiAccordionDetails = {
  styleOverrides: {
    root: {
      display: 'block',
    },
  },
};

export default MuiAccordionDetails;
